<script setup lang="ts">
const { public: { appVersion } } = useRuntimeConfig()
</script>

<template>
  <div class="app-version">
    {{ appVersion }}
  </div>
</template>

<style scoped>
.app-version {
  position: absolute;
  bottom: 10px;
  right: 10px;
  font-size: 12px;
  color: #ffffff80;
}
</style>
